import { NomineeCompanyDetails_companyById_businessAddress } from "../../api/queries/graphql/NomineeCompanyDetails";

export const getRegisterCourtDirectoryURL = (
  address: NomineeCompanyDetails_companyById_businessAddress
) => {
  if (!address.city || !address.postalCode) return null;

  return `https://www.justizadressen.nrw.de/de/justiz/gericht?ang=handelsreg&plz=${address.postalCode}&ort=${address.city}&utm_source=app&utm_medium=app`;
};
